//import { setPassiveTouchGestures } from '@polymer/polymer/lib/utils/settings';

/**
 * NOTE(keanulee): Ideally we would just `import '@babel/polyfill'` and rely
 * on babel-preset-env's useBuiltIns
 * (https://babeljs.io/docs/en/babel-preset-env#usebuiltins) to detect language
 * features, but webcomponents-sd-ce-pf.js already imports some language
 * features, such as Symbol, which conflicts with '@babel/polyfill'. So
 * instead, we just import the features we know we need.
 */
import 'regenerator-runtime/runtime';

// To force all event listeners for gestures to be passive.
// See https://www.polymer-project.org/3.0/docs/devguide/settings#setting-passive-touch-gestures
//setPassiveTouchGestures(true);

import Bugsnag from '@bugsnag/js';
import {ConfigService} from "./app/services/config.service";

await ConfigService.init().then();
if (ConfigService.get('ENVIRONMENT') !== 'local') {
    Bugsnag.start({
        apiKey: ConfigService.get('BUGSNAG_KEY') as string,
        releaseStage: ConfigService.get('ENVIRONMENT') as string
    });
}

import './app/views/loading/loading';
import './styles/styles.css';
import '@shoelace-style/shoelace/dist/themes/light.css';
import '@shoelace-style/shoelace/dist/components/select/select.js';
import '@shoelace-style/shoelace/dist/components/option/option.js';
import '@shoelace-style/shoelace/dist/components/dropdown/dropdown.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button.js';
import '@shoelace-style/shoelace/dist/components/menu/menu.js';
import '@shoelace-style/shoelace/dist/components/tag/tag.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';